import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from '@chakra-ui/react';

/**
 * Boas-vindas do portal do aluno. Hoje só aparece como fallback do
 * `MuralInformativos`, quando não há nenhum cartaz publicado - por isso ocupa a
 * largura do container e deixa o posicionamento para quem o renderiza.
 */
export default function Aviso() {
	return (
		<Alert status="info" borderRadius="20px" width="100%">
			<AlertIcon />
			<Box>
				<AlertTitle>Bem vindo a Windfall!</AlertTitle>
				<AlertDescription>Desejamos a você uma excelente experiência de aprendizado!</AlertDescription>
			</Box>
		</Alert>
	);
}
